import { FunctionalComponent, h } from '@stencil/core';
import { AppLink, AppMedia, AppRTE } from './'

interface AppOffsetGalleryItem {
    Title: string;
    Description: string;
    Media: any;
    Link: any;
    Index: number;
}


export const AppOffsetGalleryItem: FunctionalComponent<AppOffsetGalleryItem> = ({ Title, Description, Media, Link, Index }) => {

    return (
        <div class={Index > 2 ? 'uk-visible@s': ''}>
            <div class={`uk-background-primary-diag-${Index % 2} uk-text-center@s uk-padding uk-light uk-cover-container ${Media ? 'uk-animation-toggle' : ''}`} tabindex="0">
                <AppMedia className="uk-animation-fade uk-ghost" media={Media} size="(max-width: 638px) 50vw, (max-width: 958px) 30vw, 20vw" cover />
                <h3 class="uk-heading-medium uk-margin-small-top uk-margin-small-bottom">{Title}</h3>
                <AppRTE className='uk-margin-remove-top' markdown={Description} />
                <AppLink className='uk-button uk-margin-small-top uk-button-default' data={Link} />
            </div>
        </div>
    )
};